module.exports = __webpack_public_path__ + "img/7ccbc.f2b078b1.svg";